/**
 *  view html 에 youtube oembed 태그 등 있을 경우, 
 *  iframe 으로 변환 시켜주는 컴포넌트
 */
import React from 'react';
import parse, { DOMNode, Element } from 'html-react-parser';



interface Props {
    html: string;
    index?: null | number
}

const ParsedHtmlContent: React.FC<Props> = ({ html }) => {
    const transform = (domNode: DOMNode, _index: number) => {
        if (
            domNode instanceof Element &&
            domNode.name === 'oembed' &&
            domNode.attribs?.url
        ) {
            const url = domNode.attribs.url;

            // YouTube 변환 로직
            if (url.includes('youtube.com') || url.includes('youtu.be')) {
                let videoId = '';
                try {
                    const parsedUrl = new URL(url);
                    if (parsedUrl.hostname === 'youtu.be') {
                        videoId = parsedUrl.pathname.slice(1);
                    } else {
                        videoId = parsedUrl.searchParams.get('v') || '';
                    }
                } catch {
                    return null;
                }

                if (videoId) {
                    return (
                        <iframe
                            className='view-iframe'
                            src={`https://www.youtube.com/embed/${videoId}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    );
                }
            }

            // fallback: 링크로 대체
            return <a href={url}>{url}</a>;
        }

        return undefined; // 변경하지 않음
    };

    // return <div>{parse(html, { replace: transform })}</div>;
    return <div className={`ck-content`}>{html ? parse(String(html), { replace: transform }) : null}</div>;

};

export default ParsedHtmlContent;